module.exports = __webpack_public_path__ + "img/clutch.50697d3d.svg";